/////////////////////////////////////////////////////////////////////////////////////////////////////////
// 화일명 : useBackendStatus.ts
// 백엔드 서버 연결상태를 주기적으로 확인하는 공통 훅
//  - API_BASE_URL 루트('/')에 주기적으로 요청을 보내 응답 여부로 온라인/오프라인 판단
/////////////////////////////////////////////////////////////////////////////////////////////////////////
import { useEffect, useState } from 'react';
import axios from 'axios';
import { API_BASE_URL } from '../config';

export function useBackendStatus(intervalMs: number = 30000): boolean {
  const [online, setOnline] = useState(true);

  useEffect(() => {
    let cancelled = false;

    const check = async () => {
      try {
        await axios.get(`${API_BASE_URL}/`, { timeout: 4000 });
        if (!cancelled) setOnline(true);
      } catch {
        if (!cancelled) setOnline(false);
      }
    };

    check();
    const id = setInterval(check, intervalMs);
    return () => { cancelled = true; clearInterval(id); };
  }, [intervalMs]);

  return online;
}
